import { TimesheetReportType } from 'containers/timesheets/Timesheets';
import { usePermissions } from 'hooks';
import { isNil } from 'lodash';
import { useCallback } from 'react';
import ITimeOff from 'types/TimeOff';
import { dateUtils, stringUtils } from 'utils';
import { t } from 'utils/localize';
import { getFullNameFromMember } from 'utils/stringUtils';
import { ITimeEntryDataTableRow } from '../TimeEntryDataTable';

export function useTimeOffToTimeOffRowMap() {
  const { hasPermissionToManage } = usePermissions();

  return useCallback(
    (timeOff: ITimeOff): ITimeEntryDataTableRow => {
      const dateStamp = dateUtils.dateTimeFromISOKeepZone(timeOff.dateStamp);
      return {
        id: timeOff.id,
        key: timeOff.id + dateUtils.getDateString(dateStamp, 'ccc, LLL d', true),
        startDate: dateStamp,
        endDate: dateStamp,
        member: timeOff.member,
        date: dateUtils.getDateString(dateStamp, 'ccc, LLL d', true),
        day: dateStamp,
        employee: getFullNameFromMember(timeOff.member),
        type: timeOff.paid ? t('PTO') : t('Unpaid'),
        total: stringUtils.getTotalAsHoursMinutesSeconds(timeOff.seconds ? timeOff.seconds : 0),
        totalSeconds: timeOff.seconds ? timeOff.seconds : 0,
        start: '---',
        startSup: null,
        end: '---',
        endSup: null,
        description: timeOff.description,
        timeOffType: timeOff.type,
        actions: null,
        // Metadata not shown in table
        timesheetReportType: timeOff.paid ? TimesheetReportType.TIME_OFF_PAID : TimesheetReportType.TIME_OFF_UNPAID,
        canManage: timeOff.member ? hasPermissionToManage(timeOff.member, 'manageTimeEntries') : false,
        isArchived: !isNil(timeOff.member.archivedOn),
        exportStartISO: 'dont care',
        exportEndISO: 'dont care',
      };
    },
    [hasPermissionToManage]
  );
}
